import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	sitePickerFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sitePickerError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sitePickerFieldLabel: {
		id: 'issue-create.modal.create-form.site-picker.site-picker-field-label',
		defaultMessage: 'Site',
		description: 'Label for site field',
	},
	sitePickerError: {
		id: 'issue-create.modal.create-form.site-picker.site-picker-error',
		defaultMessage: 'Error in fetching the site options',
		description: 'Error message for site option load failure',
	},
});
export default messages;
